import { atom } from '@meteor/ui';

export let extraPanelAtom = atom<
  'closed' | 'docs' | 'api' | 'changelog' | 'support' | 'feedback'
>('closed');
